<template>
  <div class="bgChar-cla">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      style="width: 250px; height:120px;"
    >
      <defs>
        <linearGradient id="line" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color:#327AFC;stop-opacity:0" />
          <stop offset="100%" style="stop-color:#68FFD3;stop-opacity:1" />
        </linearGradient>
        <linearGradient id="line2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color:blue;stop-opacity:0" />
          <stop offset="100%" style="stop-color:#ffffff;stop-opacity:1" />
        </linearGradient>
        <g id="Port">
          <path d="M 30 100 A 90 90 1 1 0 210 100"></path>
        </g>
      </defs>

      <use class="circle11-cla" stroke="url(#line)" xlink:href="#Port" />
      <use
        stroke-dasharray="90,315"
        stroke="url(#line2)"
        class="circle12-cla"
        xlink:href="#Port"
      />
      <use class="circle21-cla" stroke="url(#line)" xlink:href="#Port" />
      <use
        stroke-dasharray="90,315"
        stroke="url(#line2)"
        class="circle22-cla"
        xlink:href="#Port"
      />
    </svg>
    <div class="juxing-cla"></div>
    <div class="char-text-cla">
      <slot></slot>
    </div>
    <div class="chart-title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      count: 1
    }
  },
  mounted() {
    setInterval(() => {
      if (this.count === 1) {
        this.count = 0
      } else {
        this.count = 1
      }
    }, 1000)
  }
}
</script>

<style scoped lang="less">
.bgChar-cla {
  position: relative;
}
.char-text-cla {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 27px;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #c9d3f5;
}

.chart-title {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}

@keyframes dash {
  from {
    stroke-dashoffset: -315;
  }
  to {
    stroke-dashoffset: 90;
  }
}

@keyframes dash2 {
  from {
    stroke-dashoffset: 90;
  }
  to {
    stroke-dashoffset: -315;
  }
}

.circle11-cla {
  fill: none;
  stroke-width: 2;
  transform: translateY(5px) rotateX(60deg) rotateY(0deg) rotateZ(0deg);
}

.circle12-cla {
  fill: none;
  stroke-width: 2;
  position: relative;
  stroke-dashoffset: 0;
  animation: dash 5s linear infinite;
  transform: translateY(5px) rotateX(60deg) rotateY(0deg) rotateZ(0deg);
}

.circle21-cla {
  fill: none;
  stroke-width: 2;
  transform: translateZ(10px) translateY(15px) rotateX(60deg) rotateY(0deg)
    rotateZ(0deg);
}

.circle22-cla {
  fill: none;
  stroke-width: 2;
  position: relative;
  stroke-dashoffset: 0;
  animation: dash2 5s linear infinite;
  transform: translateZ(10px) translateY(15px) rotateX(60deg) rotateY(0deg)
    rotateZ(0deg);
}

.juxing-cla {
  position: absolute;
  top: 30px;
  left: 40px;
  width: 160px;
  height: 60px;
  background-size: 100% 100%;
  background-image: url('../../../assets/chart/tongji_img.png');
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/statistical/bgChar.vue